const FilterBar = ({ titles, selectedOptions, onOptionSelect }) => {
	const getLabel = (option) => {
		const selected = selectedOptions.find((o) => o.id === option.id);
		return (
			<div className='hoverable centerAll'>
				<div>{option.label}</div>
				<div>{selected ? '✔️' : ''}</div>
			</div>
		);
	};

	return (
		<div>
			<div className='centerAll mb-1 text-set3'>
				<i className='fas fa-filter me-2'></i>
				<div className='fs-4 text-center'>Filters</div>
			</div>
			<div className='filterBar'>
				{titles.map((title, index) => (
					<div
						key={title.id}
						className='filterSection'>
						<div
							className='filterTitle text-center px-4 py-1'
							style={index === 0 ? { borderRadius: '5px 5px 0 0' } : {}}>
							{title.label}
						</div>
						<div
							className='filterContent p-2 fs-7'
							style={index === titles.length - 1 ? { borderBottom: 'none' } : {}}>
							<div className='row gy-2 text-center'>
								{title.options.map((option) => (
									<div
										className='col-6'
										key={option.id}
										value={option.value}
										onClick={() => onOptionSelect(option)}>
										{getLabel(option)}
									</div>
								))}
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default FilterBar;
